import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'recompose';

import type { ExecuteAction, ExecuteMutation } from 'bundles/author-s12n/components/types';
import Naptime from 'bundles/naptimejs';

const withFluxibleContextAsProps =
  <
    PropsOut extends { executeAction?: ExecuteAction<Payload>; executeMutation?: ExecuteMutation<Payload> } & PropsIn,
    PropsIn,
    Payload
  >() =>
  (WrappedComponent: React.ComponentType<PropsOut>) => {
    return class Wrapper extends React.Component<PropsIn> {
      static displayName = `withFluxibleContextAsProps(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      static contextTypes = {
        executeAction: PropTypes.func,
        executeMutation: PropTypes.func,
        getStore: PropTypes.func,
      };

      render() {
        return <WrappedComponent {...this.props} {...this.context} />;
      }
    };
  };

export default <
    PropsOut extends { executeAction?: ExecuteAction<Payload>; executeMutation?: ExecuteMutation<Payload> } & PropsIn,
    PropsIn,
    Payload
  >() =>
  (WrappedComponent: React.ComponentType<PropsOut>) =>
    compose<PropsOut, PropsIn>(
      Naptime.createContainer(() => ({})), //  is responsible for passing the executeMutation child context and prop that's used in the component, calling it with an empty function allows us to just get that prop without triggering any data fetching
      withFluxibleContextAsProps<PropsOut, PropsIn, Payload>()
    )(WrappedComponent);
